import { EnumerationsExportStatus } from 'client'
import type { TransferObjectsPlanInfo } from 'client'
import type { TPlanOrNull } from '~/constants/types/aap'
import type { ILeftRightBottomTextParams } from '~/constants/types'
import { COPY } from '~/constants/strings'
import { transformEnumerationComplianceTypeToString } from '~/utils/transforms'

export const convertPlanToPlanInfoFormat = (
  plan: TransferObjectsPlanInfo | null
): TPlanOrNull => {
  if (!plan) return null
  return {
    ...plan,
    planType: plan?.planType?.toString(),
    ...(plan.complianceTypeID && {
      complianceType: transformEnumerationComplianceTypeToString(
        plan.complianceTypeID
      ),
    }),
  }
}

export const availableSubPlansBottomText = (o: ILeftRightBottomTextParams) => {
  return `${o.filteredOptions?.[COPY.AVAILABLE_SUB_PLANS]?.length} of ${
    o.data[COPY.AVAILABLE_SUB_PLANS]?.length
  } Sub Plans Available`
}

export const includedSubPlanBottomText = (
  o: ILeftRightBottomTextParams
): string => {
  const isFiltered =
    o.filteredOptions?.[COPY.INCLUDED_SUB_PLANS]?.length !==
    o.data[COPY.INCLUDED_SUB_PLANS]?.length

  const numberIncludedString = isFiltered
    ? `${o.filteredOptions?.[COPY.INCLUDED_SUB_PLANS]?.length} of ${
        o.data[COPY.INCLUDED_SUB_PLANS]?.length
      }`
    : `${o.filteredOptions?.[COPY.INCLUDED_SUB_PLANS]?.length}`

  return `${numberIncludedString} Sub Plans Included`
}

export const transformExportStatusTypeToExportMessage = (
  exportStatus: EnumerationsExportStatus,
  isSummaryExport?: boolean
) => {
  const determineExportName = (reportExportString: string) =>
    isSummaryExport
      ? reportExportString.replace('Report Export', 'Summary Export')
      : reportExportString
  switch (exportStatus) {
    case EnumerationsExportStatus.Cancelled:
      return determineExportName(COPY.REPORT_EXPORT_CANCELLED)
    case EnumerationsExportStatus.InProgress:
      return determineExportName(COPY.REPORT_EXPORT_IN_PROGRESS)
    case EnumerationsExportStatus.Failed:
      return determineExportName(COPY.REPORT_EXPORT_FAILED)
    default:
      return determineExportName(COPY.REPORT_EXPORT_COMPLETE)
  }
}
